<script setup lang="ts">
import { ref, computed } from 'vue'
import SmallModel from '@/components/Interface/Modal/ModelSizes/SmallModel.vue'
import FormSelect from '@/components/Elements/Forms/FormSelect.vue'
import Backend from '@/models/backend.ts'
import { useGameStore } from "@/stores/gameStore.ts"
import { usePlanetGroupStore } from '@/stores/planetGroupStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore()
const planetGroupStore = usePlanetGroupStore()

// Backend instance
const backend = new Backend()

// Selected group reference
const selectedGroup = ref()

// Compute sorted planet groups as options
const planetGroupOptions = computed(() =>
  Array.from(planetGroupStore.planetGroups.values())
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((group) => ({ value: group.id, label: group.name }))
)

const selectAndSubmit = (val: string | number) => {
  selectedGroup.value = val
  submit()
}

// Submit function
const submit = () => {
  backend.attachPlanetToGroup(selectedGroup.value, gameStore.modalData).then(() => {
    gameStore.modalType = ''
  })
}
</script>

<template>
  <SmallModel :title="t('modals.attachToPlanetGroup.title')">
    <div class="p-2">
      <p class="pb-3 text-subtext">{{ t('modals.attachToPlanetGroup.description', { count: gameStore.modalData.length }) }}</p>
      <FormSelect
        :modelValue="selectedGroup"
        @update:modelValue="selectAndSubmit"
        :options="planetGroupOptions"
        :placeholder="t('modals.attachToPlanetGroup.selectPlaceholder')"
      />
    </div>
  </SmallModel>
</template>

<style scoped lang="scss">
.table-container {
  height: 30rem;
  overflow-y: auto;
}
</style>
